import { render, staticRenderFns } from "./NormalLoader.vue?vue&type=template&id=478e1f86&scoped=true&"
import script from "./NormalLoader.vue?vue&type=script&lang=js&"
export * from "./NormalLoader.vue?vue&type=script&lang=js&"
import style0 from "./NormalLoader.vue?vue&type=style&index=0&id=478e1f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e1f86",
  null
  
)

export default component.exports